import {emptyProposal} from '@artemis-group/aiw-contracts';

/** Source wording is retained privately; it never becomes verified scope or geometry. */
export function proposalFromLead(lead: {contact_name?:string|null;contact_hint?:{name?:string|null;address?:string|null}|null;suburb?:string|null;postcode?:string|null;address?:string|null;raw_brief?:string|null}) {
  // The enquiry's street line with its suburb and postcode — the same line the "Work site address" list offers.
  const street=lead.address??lead.contact_hint?.address??null;
  const site=street?[street,[lead.suburb,lead.postcode].filter(Boolean).join(' ')].filter(Boolean).join(', '):lead.suburb??'';
  const doc=emptyProposal(lead.contact_name??lead.contact_hint?.name??'',site);
  doc.brief.notes=(lead.raw_brief??'').replace(/\[spacer\]/gi,' ').replace(/\s+/g,' ').trim().slice(0,2000);
  return doc;
}

/** A Proposal with no site address takes the place the enquiry or the job states — the first such line of its
 *  own "Work site address" list. Never over a typed address, and never the customer's home or another job's site
 *  (those are offered, not assumed). Report 89bffef3: Fiona's Proposal stayed blank after the address was saved. */
export function blankSiteFill(siteAddress:string,lines:readonly {value:string;source:string}[]|undefined):string|null{
  if(siteAddress.trim())return null;
  return lines?.find(l=>l.source==='enquiry'||l.source==='job')?.value??null;
}
